import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';
import { spaceM } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const StyledLoadingContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 150px;
`;

const StyledLoadingIconContainer = styled.div`
  margin-bottom: ${spaceM};
`;

export const FlagLoading: FC = () => (
  <StyledLoadingContainer>
    <StyledLoadingIconContainer>
      <DotLoadingIndicator />
    </StyledLoadingIconContainer>
    <BodyCopy size="small" lineHeight="dense" noMargin>
      <FormattedMessage id="USER_FLAG_LOADING" />
    </BodyCopy>
  </StyledLoadingContainer>
);
